
import { createSlice } from "@reduxjs/toolkit";

const user_acct = 'john doe';

const initialState = [
    {
        test_name: null,
        id: 1,
        first_name: "Florence",
        last_name:  "Francis",
        user_email: "@gmail.com",
        mobile_num: +23456789009,
        user_pwd: '12345',
        // current_password: "",
        new_pasword: "",
        logo: 'logo here',
        // for zero balnce check and mount component
        user_bal: 48500,
        percentage: '25%',
        app_name: 'fundlet',
        mode: false,
        total_withdrawal: 0,
        total_deposit: 0,
        received_income: 0,
        // balance: 0,

        package_features: [
            {
                package_name: 'combo',
                amt: 6250,
                btnTxt: 'choose package',
            },
            {
                package_name: 'platinum',
                amt: 12500,
                btnTxt: 'choose package'
            },
            {
                package_name: 'ultimate',
                amt: 25000,
                btnTxt: 'choose package'
            }
        ],

        notification: {
            notifyText: "Notifications",
            msgs: {
                all: [
                        {
                            id: 1,
                            heading: 'Login attempted from n...',
                            txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                            date: '2023-02-02',
                            time: '07:31:05'
                        },
                        {
                            id: 2,
                            heading: `You've received a new...`,
                            txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                            date: '2023-02-02',
                            time: '07:31:05'
                        },
                        {
                            id: 3,
                            heading: `You've received a new...`,
                            txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                            date: '2023-02-02',
                            time: '07:31:05'
                        },
                        {
                            id: 4,
                            heading: `You've received a new...`,
                            txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                            date: '2023-02-02',
                            time: '07:31:05'
                        },
                        {
                            id: 5,
                            heading: 'Login attempted from n...',
                            txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                            date: '2023-02-02',
                            time: '07:31:05'
                        },
                        {
                            id: 6,
                            heading: `You've received a new...`,
                            txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                            date: '2023-02-02',
                            time: '07:31:05'
                        },
                        {
                            id: 7,
                            heading: 'Login attempted from n...',
                            txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                            date: '2023-02-02',
                            time: '07:31:05'
                        },
                    ],
        
                activities: [
                    {
                        id: 1,
                        heading: `You've received a new...`,
                        txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                        date: '2023-02-02',
                        time: '07:31:05'
                    },
                    {
                        id: 2,
                        heading: `You've received a new...`,
                        txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                        date: '2023-02-02',
                        time: '07:31:05'
                    },
                    {
                        id: 3,
                        heading: `You've received a new...`,
                        txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                        date: '2023-02-02',
                        time: '07:31:05'
                    },
                    {
                        id: 4,
                        heading: `You've received a new...`,
                        txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                        date: '2023-02-02',
                        time: '07:31:05'
                    },
                ],
        
                devices: [
                    {
                        id: 1,
                        heading: 'Login attempted from n...',
                        txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                        date: '2023-02-02',
                        time: '07:31:05'
                    },
                    {
                        id: 2,
                        heading: 'Login attempted from n...',
                        txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                        date: '2023-02-02',
                        time: '07:31:05'
                    },
                    {
                        id: 3,
                        heading: 'Login attempted from n...',
                        txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                        date: '2023-02-02',
                        time: '07:31:05'
                    },
                    {
                        id: 4,
                        heading: 'Login attempted from n...',
                        txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                        date: '2023-02-02',
                        time: '07:31:05'
                    },
                    {
                        id: 5,
                        heading: 'Login attempted from n...',
                        txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                        date: '2023-02-02',
                        time: '07:31:05'
                    },
                    {
                        id: 6,
                        heading: 'Login attempted from n...',
                        txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                        date: '2023-02-02',
                        time: '07:31:05'
                    },
                    {
                        id: 7,
                        heading: 'Login attempted from n...',
                        txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                        date: '2023-02-02',
                        time: '07:31:05'
                    },
                    
                ]
            }
        },

        // another_user_details_goes_here

    }
];

export const userDetailsSlice = createSlice({
    name: 'user/details',
    initialState,
    reducers: {
        saveUserPwd: (state, action)=>{
            state[0].user_pwd = ()=> {
                if(state[0].id === action.payload.id){
                state[0].user_pwd = action.payload.user_pwd
                }
            }

            // state[0].user_pwd = state[0].user_pwd = action.payload.user_pwd


            // state[0].user_pwd = state[0].id === action.payload.id ? state[0].user_pwd = action.payload.user_pwd : state[0].user_pwd
        },

        updateFirstName: (state, action)=>{
            state[0].first_name = action.payload
        },

        updateLastName: (state, action)=>{
            state[0].last_name = action.payload
        },
        updateEmail: (state, action)=>{
            state[0].user_email = action.payload
        },
        updateMobilNum: (state, action)=>{
            state[0].last_name = action.payload
        },
        
    }
});

export const { saveUserPwd, updateFirstName, updateLastName, updateEmail, updateMobilNum } = userDetailsSlice.actions;

export const general = (state) => state.userDetail[0];

export const selectUser = state => state.userDetail[0].first_name;

export const userBal = state => state.userDetail[0].userBal

export default userDetailsSlice.reducer;